"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useRouter } from "next/navigation";
import React, { useEffect, useState } from "react";
import { FieldValues, useForm } from "react-hook-form";
import EventReadDetail from "@/app/(main)/(club)/mes-clubs/[id]/components/event-read-detail";
import { useAlreadyInvitedDates } from "@/app/(main)/(club)/mes-clubs/[id]/invitations/hooks/useAlreadyInvitedDates";
import { convertStringToDate } from "@/app/(main)/(club)/mes-clubs/[id]/utils/utils";
import ParticipationEventDatePickerInput from "@/app/(main)/_club_components/participation-event-date-picker-input";
import PresidentTitle from "@/app/(main)/_club_components/president-title";
import { getClubEvent } from "@/app/api/dynabuy-back/api-events";
import { postParticipation } from "@/app/api/dynabuy-back/api-invitations";
import Button from "@/components/button";
import ClientFlash from "@/components/global/client-flash";
import ComponentLoading from "@/components/global/component-loading";
import useSubmit from "@/hooks/use-submit";
import { EventEnum } from "@/TS/Enums/global_enums";
import { Club, EventRead, ParticipationWrite } from "@/TS/Interfaces/global_interfaces";
export default function UserParticipationForm(props) {
  const $ = _c(69);
  const router = useRouter();
  const {
    register,
    setValue,
    handleSubmit
  } = useForm();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      message: "Votre demande a \xE9t\xE9 envoy\xE9e au pr\xE9sident du Club d\u2019Affaires. Elle est en cours de validation. Vous recevrez une r\xE9ponse par e-mail tr\xE8s prochainement.",
      type: "success2",
      position: "mes-clubs_page"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    loading,
    onSubmit,
    setVal: t1
  } = useSubmit(postParticipation, {
    callbackMessage: t0,
    callback: () => {
      setTimeout(() => {
        router.push("/mes-clubs");
        setVal("");
      }, 1000);
    },
    errorFlashPath: "/participation"
  });
  const setVal = t1;
  let t2;
  let t3;
  if ($[1] !== router) {
    t2 = () => {
      if (router?.prefetch) {
        router.prefetch("/mes-clubs");
      }
    };
    t3 = [router];
    $[1] = router;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  const [activeEvent, setActiveEvent] = useState(undefined);
  const [isLoadingEvent, setIsLoadingEvent] = useState(false);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      forUser: "only"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const alreadyInvitedDates = useAlreadyInvitedDates(props.club.slug, t4);
  let t5;
  if ($[5] !== props.club.slug || $[6] !== setValue) {
    t5 = async (fieldName, fieldValue) => {
      setIsLoadingEvent(true);
      setValue(fieldName, fieldValue);
      try {
        const fetchEvent = async () => await getClubEvent(EventEnum.MEETING, props.club.slug, convertStringToDate(fieldValue));
        setActiveEvent(await fetchEvent());
      } catch {
        setActiveEvent(null);
      }
      setIsLoadingEvent(false);
    };
    $[5] = props.club.slug;
    $[6] = setValue;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const setSelectedEvent = t5;
  let t6;
  if ($[8] !== activeEvent || $[9] !== props.club) {
    t6 = data => {
      data.eventMeeting = activeEvent["@id"];
      data.club = props.club["@id"].replace(/\/dashboard$/, "");
      delete data.dayofmonth;
      return data as ParticipationWrite;
    };
    $[8] = activeEvent;
    $[9] = props.club;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const transformSubmit = t6;
  if (props.isLogged) {
    let t7;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <h4 className="text-xl md:text-3xl font-bold  mb-8 md:mb-10 text-center">Demande de participation à une réunion découverte</h4>;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    let t8;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <p className="mb-10"><b>Pour rejoindre le Club d’affaires, vous devez envoyer une demande de participation à une réunion au président du Club.</b>Une fois celle-ci validée par le président, un e-mail de confirmation vous sera envoyé.</p>;
      $[12] = t8;
    } else {
      t8 = $[12];
    }
    let t9;
    if ($[13] !== onSubmit || $[14] !== transformSubmit) {
      t9 = data_0 => onSubmit(transformSubmit(data_0));
      $[13] = onSubmit;
      $[14] = transformSubmit;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    let t10;
    if ($[16] !== handleSubmit || $[17] !== t9) {
      t10 = handleSubmit(t9);
      $[16] = handleSubmit;
      $[17] = t9;
      $[18] = t10;
    } else {
      t10 = $[18];
    }
    const t11 = props.club?.displayName;
    let t12;
    if ($[19] !== t11) {
      t12 = <h3 className="h3">{t11}</h3>;
      $[19] = t11;
      $[20] = t12;
    } else {
      t12 = $[20];
    }
    const t13 = props.club?.president;
    const t14 = props.club?.name;
    let t15;
    if ($[21] !== t13 || $[22] !== t14) {
      t15 = <PresidentTitle president={t13} clubName={t14} />;
      $[21] = t13;
      $[22] = t14;
      $[23] = t15;
    } else {
      t15 = $[23];
    }
    let t16;
    if ($[24] !== t12 || $[25] !== t15) {
      t16 = <div className="rounded bg-info p-5 mb-8">{t12}{t15}</div>;
      $[24] = t12;
      $[25] = t15;
      $[26] = t16;
    } else {
      t16 = $[26];
    }
    let t17;
    if ($[27] !== alreadyInvitedDates || $[28] !== loading || $[29] !== props.club.slug || $[30] !== register || $[31] !== setSelectedEvent) {
      t17 = <div className="flex my-4"><ParticipationEventDatePickerInput mobileSize={1580} setValue={setSelectedEvent} clubSlug={props.club.slug} loading={loading} register={register} alreadyInvitedDates={alreadyInvitedDates} /></div>;
      $[27] = alreadyInvitedDates;
      $[28] = loading;
      $[29] = props.club.slug;
      $[30] = register;
      $[31] = setSelectedEvent;
      $[32] = t17;
    } else {
      t17 = $[32];
    }
    let t18;
    if ($[33] !== isLoadingEvent) {
      t18 = isLoadingEvent && <ComponentLoading />;
      $[33] = isLoadingEvent;
      $[34] = t18;
    } else {
      t18 = $[34];
    }
    let t19;
    if ($[35] !== activeEvent) {
      t19 = activeEvent && <div className="p-4 mt-4"><EventReadDetail event={activeEvent} /></div>;
      $[35] = activeEvent;
      $[36] = t19;
    } else {
      t19 = $[36];
    }
    let t20;
    if ($[37] !== activeEvent) {
      t20 = null === activeEvent && <div className="rounded bg-info p-4 mt-4"><p>Impossible de charger l'évènement</p></div>;
      $[37] = activeEvent;
      $[38] = t20;
    } else {
      t20 = $[38];
    }
    let t21;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = <ClientFlash path="/participation" />;
      $[39] = t21;
    } else {
      t21 = $[39];
    }
    let t22;
    if ($[40] !== setVal) {
      t22 = <Button type="button" variant="unfilled" colorTheme="secondary" className="my-6 w-52 mx-2" onClick={() => {
        setVal("");
      }}>Annuler</Button>;
      $[40] = setVal;
      $[41] = t22;
    } else {
      t22 = $[41];
    }
    const t23 = loading || !activeEvent;
    let t24;
    if ($[42] !== t23) {
      t24 = <Button type="submit" className="my-6 w-52 mx-2" disabled={t23}>Envoyer ma demande</Button>;
      $[42] = t23;
      $[43] = t24;
    } else {
      t24 = $[43];
    }
    let t25;
    if ($[44] !== t22 || $[45] !== t24) {
      t25 = <div className="flex flex-col"><div className="flex justify-center flex-wrap">{t22}{t24}</div></div>;
      $[44] = t22;
      $[45] = t24;
      $[46] = t25;
    } else {
      t25 = $[46];
    }
    let t26;
    if ($[47] !== t10 || $[48] !== t16 || $[49] !== t17 || $[50] !== t18 || $[51] !== t19 || $[52] !== t20 || $[53] !== t25) {
      t26 = <div className="flex flex-col">{t7}{t8}<form onSubmit={t10} className="flex w-full flex-col max-w-[600px] mx-auto">{t16}{t17}{t18}{t19}{t20}{t21}{t25}</form></div>;
      $[47] = t10;
      $[48] = t16;
      $[49] = t17;
      $[50] = t18;
      $[51] = t19;
      $[52] = t20;
      $[53] = t25;
      $[54] = t26;
    } else {
      t26 = $[54];
    }
    return t26;
  } else {
    let t7;
    if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <h4 className="text-xl font-bold my-6">Demande de participation à une réunion découverte</h4>;
      $[55] = t7;
    } else {
      t7 = $[55];
    }
    let t8;
    if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <p className="mb-4 italic text-sm">Pour participer à une réunion découverte, vous devez avoir un compte.<br />Merci d'en créer un.</p>;
      $[56] = t8;
    } else {
      t8 = $[56];
    }
    let t9;
    if ($[57] !== setVal) {
      t9 = <Button type="button" variant="unfilled" colorTheme="secondary" className="my-6 w-52 mx-2" onClick={() => {
        setVal("");
      }}>Annuler</Button>;
      $[57] = setVal;
      $[58] = t9;
    } else {
      t9 = $[58];
    }
    const t10 = props.club?.slug;
    let t11;
    if ($[59] !== t10) {
      t11 = {
        pathname: "/inscription",
        query: {
          participation: t10
        }
      };
      $[59] = t10;
      $[60] = t11;
    } else {
      t11 = $[60];
    }
    let t12;
    if ($[61] !== setVal) {
      t12 = <Button type="button" className="my-6 w-52 mx-2" onClick={() => {
        setVal("");
      }}>Créer mon compte</Button>;
      $[61] = setVal;
      $[62] = t12;
    } else {
      t12 = $[62];
    }
    let t13;
    if ($[63] !== t11 || $[64] !== t12) {
      t13 = <Link href={t11}>{t12}</Link>;
      $[63] = t11;
      $[64] = t12;
      $[65] = t13;
    } else {
      t13 = $[65];
    }
    let t14;
    if ($[66] !== t13 || $[67] !== t9) {
      t14 = <div className="flex flex-col text-center">{t7}{t8}<div>{t9}{t13}</div></div>;
      $[66] = t13;
      $[67] = t9;
      $[68] = t14;
    } else {
      t14 = $[68];
    }
    return t14;
  }
}